<template>
  <v-btn
    class="app-button"
    :class="[
      {
        'app-button--second': secondary,
        'app-button--custom': customColors,
        'width-limits-small': !icon && small && !block && !wide,
        'width-limits-standard': !icon && !small && !block && !wide,
        shadow: shadow,
        'no-hover': noHover || $vuetify.display.mobile,
        loading: loading,
        'v-btn--icon': icon
      }
    ]"
    :block="block"
    :variant="text || icon ? 'text' : 'flat'"
    :size="small ? 'small' : 'default'"
    :to="to"
    :href="href"
    v-bind="$attrs"
    :ripple="!($vuetify.display.mobile && icon) && Boolean($attrs.ripple)"
    :disabled="loading || disabled"
    :tabindex="tabIndex"
  >
    <loading-indicator v-if="loading" class="loading-indicator" :mode="!text && !icon && small ? 'xs' : 'sm'" />
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: false
    },
    to: {
      type: [String, Object],
      default: null
    },
    href: {
      type: String,
      default: null
    },
    icon: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    customColors: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    noHover: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: Number,
      default: null
    },
    wide: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  position: relative;
  font-size: var(--font-size-big);
  font-weight: bold;
  text-transform: none;
  letter-spacing: normal;
  box-shadow: none;
  color: inherit;

  &.shadow {
    box-shadow: var(--shadow-1) !important;
  }

  &.width-limits-standard {
    min-width: 80px;
    max-width: 256px;
  }

  &.width-limits-small {
    min-width: 40px !important;
    max-width: 200px;
  }

  &.v-btn--size-small:not(.v-btn--block) {
    height: 28px;
    padding: 0 8px;
    min-width: 0;
  }

  &.v-btn--density-default.v-btn--icon {
    width: unset;
  }

  &.no-hover {
    &:before {
      background-color: transparent !important;
    }
  }

  &:not(.v-btn--icon):not(.group-toggle-button) {
    border-radius: var(--rounded-app);
  }

  &.v-btn--size-small.v-btn--icon {
    width: 28px;
    min-width: 28px;
    height: 28px;
  }

  &:not(.v-btn--size-small) {
    height: 40px;

    &:not(.v-btn--block) {
      min-width: 40px;
    }
  }

  &--block {
    margin: 8px 0;

    :deep(.v-btn__content) {
      flex-grow: 1;
    }
  }

  &.app-button--second {
    box-shadow: none;
    border: 1px solid;
  }

  :deep(.v-btn__content) {
    line-height: inherit !important;

    i {
      font-size: inherit;
    }
  }

  &.v-btn--disabled {
    opacity: var(--disabled-button-opacity);
    color: inherit !important;

    :deep(.v-icon) {
      color: inherit !important;
    }
  }
}

.loading {
  :deep(.v-icon) {
    transition: none !important;
  }

  :deep(.v-btn__content) {
    color: transparent; // For text nodes passed to the slot

    > :not(.loading-indicator) {
      opacity: 0;
      width: 0;
    }
  }

  .loading-indicator {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    color: currentColor;
  }
}
</style>
